const paths = {
	auth: { callback: '/auth/callback', forbidden: '/auth/forbidden' },
};

export default paths;
